module.exports = __webpack_public_path__ + "static/img/11.245ec7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/eng/11.png
// module id = FYPT
// module chunks = 0